'use strict';

/*jshint esversion: 6 */
(function ($) {
	$(document).ready(function () {
		// Trigger the my reservations modal based on a given URL hash
		var hash, trigger, target, signIn, checkRates;
		// the url fragment to trigger the modal on
		trigger = 'myreservations';
		signIn = 'signin';
		checkRates = 'checkrates';
		// the modal we'll target


		var screenWidth = window.innerWidth;

		var mainHeader;
		mainHeader = $('header[role="banner"]');

		$('main').on('click', function () {
			clearScreen.all();

			if (screenWidth >= 768) {
				clearScreen.callUs();
			}
		});

		$(document).keyup(function (e) {
			if (e.keyCode === 27) {
				clearScreen.all();
				clearScreen.callUs();
			}
		});

		var megaMenuTrigger = $('.menu-level-0 > li.menu-item--expanded');
		var headerClose = mainHeader.not(megaMenuTrigger);
		var topLevelMenuItem = $('.menu-level-0 > li.menu-item');

		headerClose.on('click', function () {
			if (screenWidth >= 768) {
				clearScreen.dropDowns();
			}
		});

		// megaMenuTrigger.on('click', function(event) {
		// 	topLevelMenuItem.not(this).removeClass('open');
		// 	topLevelMenuItem.removeClass('faded');
		//
		// 	if($(this).hasClass('open')) {
		// 		$(this).removeClass('open');
		// 		topLevelMenuItem.removeClass('faded');
		// 	} else {
		// 		$(this).addClass('open');
		// 		topLevelMenuItem.not(this).addClass('faded');
		// 	}
		//
		// 	clearScreen.booking();
		// 	event.stopPropagation();
		// });

		$('.js-mega-close').on('click', function () {
			clearScreen.dropDowns();
			return false;
		});

		var primaryMenuClasses = [
		// add the names of your menus to this array
		".menu--main"];
		var primaryMenus = primaryMenuClasses.join(", ");
		var secondaryMenu = $(".menu--secondary-nav");
		var propertyMenu = $("nav.property");

		$('.menu-toggle').on('click', function () {
			$(this).toggleClass('is-active');
			$(primaryMenus).toggleClass('show');
			$(secondaryMenu).toggleClass('show');
			$(propertyMenu).toggle();
			clearScreen.booking();
		});

		$('header .btn--check-rates').on('click', function () {
			$('.check-rates').toggle();
			clearScreen.dropDowns();
			clearScreen.mobileMenu();
		});

		// Secondary nav Call Us
		var callUsTrigger, callUsDropDown, callUsClose;
		callUsTrigger = $('.menu--secondary-nav li.call');
		callUsDropDown = $('.menu--secondary-nav li.menu-item--expanded .sub-menu');

		if (callUsTrigger.length) {
			callUsTrigger.on('click', function () {
				callUsDropDown.toggle();
				if (screenWidth >= 1280) {
					clearScreen.all();
				}
			});
		}

		// Move the offers link to the main menu on mobile
		var movedLinks;
		movedLinks = $('.menu--secondary-nav > ul > li:not(".call")');
		movedLinks.addClass('moved-links');

		function moveOffers() {
			var vwWidth;
			vwWidth = window.innerWidth;

			if (vwWidth <= 1279) {
				movedLinks.appendTo('.menu--main > ul');
			} else {
				$('.moved-links').prependTo('.menu--secondary-nav > ul');
			}
		}

		moveOffers();
		window.addEventListener("resize", moveOffers, false);

		target = $('#reservations-modal');
		// check to see if the url has a hash
		if (window.location.hash) {
			// the string to search for our fragment in (the url string)
			hash = window.location.hash;
			// check to see if the trigger exists in the hash
			if (hash.includes(trigger) || hash.includes(signIn)) {
				// open the modal
				target.modal('toggle');
			}

			if (hash.includes(checkRates)) {
				$('.check-rates').show();
				console.log('check rates found in hash');
			}
		}
	});
})(jQuery);